<template>
    <div class="flex items-center justify-center gap-2">
        <div
            class="cursor-pointer flex-center bg-[#F4F4F4] hover:bg-won-gray-light rounded h-6 w-6"
            v-tooltip="{ content: 'Edit margins', placement: 'bottom' }"
            @click="showEditMarginsHandler"
        >
            <ViewColumnsIcon
                class="size-[20px] text-[#666666]"
            />
        </div>
    </div>

    <EditMarginsModal
        :showModal="showEditMargins"
        :closeModal="closeEditMarginsHandler"
    />
</template>

<script setup>
import { ref } from 'vue'

import EditMarginsModal from "../../../../modals/editor/edit-margins.vue";

import { ViewColumnsIcon } from "@heroicons/vue/24/outline";

const showEditMargins = ref(false)

const showEditMarginsHandler = () => {
    showEditMargins.value = true;
}
const closeEditMarginsHandler = () => {
    showEditMargins.value = false
}
</script>
